import { render, staticRenderFns } from "./uploadFiles.vue?vue&type=template&id=1a638f36&scoped=true"
import script from "./uploadFiles.vue?vue&type=script&lang=js"
export * from "./uploadFiles.vue?vue&type=script&lang=js"
import style0 from "./uploadFiles.vue?vue&type=style&index=0&id=1a638f36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a638f36",
  null
  
)

export default component.exports